import type { RootState } from 'RootTypes';

import { NAMESPACE } from './state';

/**
 * @function Only use getAccount if you need the entire account object.
 * If you only need some properties, use individual selectors like getEmail. Otherwise,
 * your component will re-render every time the account object is updated, whether or
 * not the properties you are using have changed.
 */
export const getAccount = (state: RootState) => state[NAMESPACE];

export const getBestSubscription = (state: RootState) => state[NAMESPACE].bestSubscription;
export const getEmail = (state: RootState) => state[NAMESPACE].email;
export const getFirstName = (state: RootState) => state[NAMESPACE].firstName;
export const getIsAuthenticated = (state: RootState) => state[NAMESPACE].isAuthenticated;
export const getIsBatsAccountLinked = (state: RootState) => state[NAMESPACE].isBatsAccountLinked;
export const getLastName = (state: RootState) => state[NAMESPACE].lastName;
export const getUserAccessLevel = (state: RootState) => state[NAMESPACE].highestAccessLevel;
export const getUserID = (state: RootState) => state[NAMESPACE].userID;
export const getRegistrationDate = (state: RootState) => state[NAMESPACE].registrationDate;

export const isUserLoaded = (state: RootState) => getUserID(state) !== undefined;
